import "./Call.scss";
import React from "react";
import { Button, Tooltip } from "@mui/material";
import App, { InterfaceAppState } from "../../App";
import { withTranslation } from "react-i18next";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import DialpadIcon from "@mui/icons-material/Dialpad"
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import { HelperUtil } from "../../utils/helper";
import Dtmf from "../../components/Dtmf/Dtmf";


class Call extends React.Component
    <any, {
        seconds: number, hideControls: boolean, biggerLocalVideo: boolean, enableHideControlFeature: boolean, dtmfOpen: boolean,
        micEnabled: boolean, hover: boolean, screenShare: boolean, flipCamera: boolean
    }>
{
    timeout: any;
    constructor(props: any) {
        super(props);

        this.state = {
            seconds: 0,
            hideControls: false,
            biggerLocalVideo: false,
            enableHideControlFeature: false,
            dtmfOpen: false,
            micEnabled: true,
            hover: false,
            screenShare: false,
            flipCamera: true,
        };
    }

    interval: any;



    render() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        const selectedCam = AppState.selectedCamera;
        const selectedMic = AppState.selectedMicrophone;
        const { t } = this.props;

        return (
            <>
                <div id="page-call" className={(AppComp.state.withStyle ? 'with-style ' : '')}>
                    <video id="remote-video" controls={false} autoPlay={true} muted={false} />
                    {!AppState.remoteVideoTrack && <VideocamOffIcon className="user-icon brighter" />}
                    {(selectedCam && !AppState.audioOnly) &&
                        <div id="div-local-video"
                            className={(this.state.biggerLocalVideo ? 'bigger ' : '') + (this.state.hideControls ? '' : 'moveup')}
                            onClick={() => {
                                this.toggleLocalVideoSize();
                            }}>
                            <video id="local-video" controls={false} autoPlay={true} muted={true}
                                className={this.state.flipCamera ? "" : "not-flipped"}
                            />
                            {this.state.biggerLocalVideo ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
                        </div>}

                    <div id="call-header" className={this.state.hideControls ? 'hidden' : ''}>
                        <span className="text-title">
                            {AppState.session?.remoteIdentity.displayName}
                        </span>
                    </div>

                    <Dtmf onDtmfClicked={this.sendDtmf} show={this.state.dtmfOpen} handleShow={this.callbackShow} t={t}></Dtmf>

                    <div id="call-controls" className={this.state.hideControls ? 'hidden' : ''}>
                        <span className="text-details">
                            {AppComp.toTimeString(this.state.seconds)}
                        </span>
                        &nbsp;&nbsp;&nbsp;
                        <Tooltip title={this.state.micEnabled ? t('disable_microphone') : t('enable_microphone')} placement="top">
                            <Button
                                className={'mic-toggle'}
                                startIcon={(this.state.micEnabled && !this.state.hover) || (!this.state.micEnabled && this.state.hover) ? <MicIcon /> : <MicOffIcon />}
                                onMouseEnter={() => { this.setState({ hover: true }) }}
                                onMouseLeave={() => { this.setState({ hover: false }) }}

                                onClick={
                                    () => {
                                        this.muteUnmute();
                                    }
                                }
                                color={this.state.micEnabled ? "success" : "error"}
                            ></Button>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;
                        <Tooltip title={this.state.dtmfOpen ? t('close_dialpad') : t('open_dialpad')} placement="top">
                            <Button
                                className={'dialpad-toggle'}
                                startIcon={<DialpadIcon />}
                                style={{}}
                                onClick={
                                    () => { this.setState({ dtmfOpen: !this.state.dtmfOpen }) }
                                }
                                color={this.state.dtmfOpen ? "success" : "error"}
                            ></Button>
                        </Tooltip>
                        {
                            !AppState.audioOnly &&
                            (<Tooltip title={this.state.screenShare ? t('stop_screen_sharing') : t('start_screen_sharing')} placement="top">
                                <Button
                                    className={'screenshare-toggle'}
                                    startIcon={<ScreenShareIcon />}
                                    style={{}}
                                    onClick={
                                        () => { this.setState({ screenShare: !this.state.screenShare }) }
                                    }
                                    color={this.state.screenShare ? "success" : "error"}
                                ></Button>
                            </Tooltip>)
                        }
                        &nbsp;&nbsp;&nbsp;
                        <Button onClick={() => {
                            AppComp.endCall();
                        }} color="error" variant="contained">{t('hangup')}</Button>

                    </div>
                    <div className={'footer-text'}>
                        {t('easy-call-me.access_page_footer_text', { "current-year": (new Date()).getFullYear().toString() })}
                    </div>
                </div>
            </>
        );
    }

    callbackShow = () => {
        this.setState({ dtmfOpen: false });
    }

    componentDidMount() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        const selectedCam = AppState.selectedCamera;

        if (selectedCam && !AppState.audioOnly) {
            const constraints: MediaStreamConstraints = {
                audio: false,
                video: { deviceId: selectedCam.deviceId }
            };

            AppComp.stopStream(null);
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                if (HelperUtil.showLogs()) {
                    console.log('The stream was successfully obtained', stream);
                }
                if (stream) {
                    AppComp.stream = stream;
                    AppComp.setupStreamToVideo(stream, 'local-video', () => {
                    }, () => {
                    });
                }
            }).catch((err) => {
                if (err) {
                    console.error('There was an error obtaining the stream', err);
                }
            });
        }

        this.interval = setInterval(() => {
            this.setState({
                seconds: this.state.seconds + 1
            });
        }, 1000);
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ seconds: number; hideControls: boolean; biggerLocalVideo: boolean, screenShare: boolean }>, snapshot?: any) {
        const AppState: InterfaceAppState = this.props.AppState;
        const AppComp = this.props.AppComp;
        if (AppState.remoteVideoTrack) {
            if (!this.state.enableHideControlFeature) {
                this.setState({
                    enableHideControlFeature: true
                }, () => {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.setState({
                            hideControls: true
                        });
                    }, 3000);

                    document.addEventListener('mousemove', this.mouseMove);
                });
            }
        }
        if (!prevState.screenShare && this.state.screenShare) {
            this.setScreenShareStream();
        }
        else if (prevState.screenShare && !this.state.screenShare) {
            this.setCameraStream();
        }
    }

    setScreenShareStream = () => {
        const AppState: InterfaceAppState = this.props.AppState;
        const AppComp = this.props.AppComp;
        if (AppState.selectedCamera && !AppState.audioOnly) {
            navigator.mediaDevices.getDisplayMedia({ video: true, audio: false }).then((stream) => {

                this.setState({ flipCamera: false })
                AppComp.stopStream(null);
                if (AppState.session) {
                    if (stream) {
                        AppComp.stream = stream;
                        AppComp.setupStreamToVideo(stream, 'local-video', () => { }, () => { });
                    }

                    const screenVideoTrack = stream.getVideoTracks()[0];
                    screenVideoTrack.onended = () => {
                        this.setState({ screenShare: false })
                        this.setCameraStream();
                    }

                    const sender = this.props.AppState.session?.sessionDescriptionHandler.peerConnection?.getSenders()
                        .find(function (s: any) {
                            return s && s.track && s.track.kind === screenVideoTrack.kind;
                        });
                    if (sender) {
                        sender.track.stop();
                        sender.replaceTrack(screenVideoTrack);
                    }
                }
            }).catch((err) => {
                if (err) {
                    this.setState({ screenShare: false })
                    console.error('There was an error obtaining the stream', err);
                }
            });
        }
    }

    setCameraStream = () => {
        const AppState: InterfaceAppState = this.props.AppState;
        const AppComp = this.props.AppComp;
        if (AppState.selectedCamera && !AppState.audioOnly) {
            const constraints: MediaStreamConstraints = {
                audio: false,
                video: { deviceId: this.props.AppState.selectedCamera.deviceId }
            };
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                this.setState({ flipCamera: true })
                AppComp.stopStream(null);
                if (AppState.session) {
                    if (stream) {
                        AppComp.stream = stream;
                        AppComp.setupStreamToVideo(stream, 'local-video', () => { }, () => { });
                    }

                    const screenVideoTrack = stream.getVideoTracks()[0];

                    const sender = this.props.AppState.session?.sessionDescriptionHandler.peerConnection?.getSenders()
                        .find(function (s: any) {
                            return s && s.track && s.track.kind === screenVideoTrack.kind;
                        });
                    if (sender) {
                        sender.track.stop();
                        sender.replaceTrack(screenVideoTrack);
                    }
                }
            }).catch((err) => {
                if (err) {
                    console.error('There was an error obtaining the stream', err);
                }
            });
        }
    }

    mouseMove = () => {
        clearTimeout(this.timeout);
        this.setState({
            hideControls: false,
        }, () => {
            this.timeout = setTimeout(() => {
                this.setState({
                    hideControls: true
                });
            }, 3000);
        });
    }

    toggleLocalVideoSize = () => {
        this.setState({
            biggerLocalVideo: !this.state.biggerLocalVideo
        });
    }

    muteUnmute = () => {
        const AppState: InterfaceAppState = this.props.AppState;
        const session = AppState.session;

        if (session) {
            const senders = (session?.sessionDescriptionHandler as any).peerConnection?.getSenders()
            const audioSender = senders.find(function (s: RTCRtpSender) {
                return s && s.track && s.track.kind === 'audio';
            });

            if (audioSender) {
                if (audioSender.track.enabled === true) {
                    if (HelperUtil.showLogs()) {
                        console.log('Microphone will be muted');
                    }
                    audioSender.track.enabled = false;
                    (session?.sessionDescriptionHandler as any).senderAudio = false;
                    this.setState({ micEnabled: false })
                } else {
                    if (HelperUtil.showLogs()) {
                        console.log('Microphone will be unmuted');
                    }
                    audioSender.track.enabled = true;
                    (session?.sessionDescriptionHandler as any).senderAudio = true;
                    this.setState({ micEnabled: true })
                }
            }
        }
    }

    sendDtmf = (dtmf: any) => {
        const AppState: InterfaceAppState = this.props.AppState;
        const session = AppState.session;

        if (HelperUtil.showLogs()) {
            console.log('Dtmf will be sent with', dtmf);
        }

        if (session) {
            const options = {
                requestOptions: {
                    body: {
                        contentDisposition: "render",
                        contentType: "application/dtmf-relay",
                        content: "Signal=" + dtmf + "\r\nDuration=100"
                    }
                }
            };

            session.info(options);
        }
    }

    componentWillUnmount() {
        const AppComp: App = this.props.AppComp;
        const seconds = this.state.seconds;

        setTimeout(() => {
            AppComp.setState({
                lastCallDurationSeconds: seconds
            });
        }, 0);

        clearInterval(this.interval);
        clearTimeout(this.timeout);
        document.removeEventListener('mousemove', this.mouseMove);
    }


}

export default withTranslation()(Call);
